import { orderConstants } from '../constants';
import { portalFunctionalityConstants } from '../constants';
import { alertActions } from 'actions';
import { orderService } from 'services';
import { gisRoutes } from '../routes/routes';
import { global } from 'config';
import { history } from 'helpers';

//using for portal order
export const orderActions = {
  get,
  getAll,
  add,
  uploadFile,
  update,
  downloadFile
};

function get(order_id) {
  return dispatch => {
    dispatch(request());

    orderService.get(order_id)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: orderConstants.GET_ORDER_REQUEST } }
  function success(data) { return { type: orderConstants.GET_ORDER_SUCCESS, data } }
  function failure(error) { return { type: orderConstants.GET_ORDER_FAILURE, error } }
}

function getAll(limit = global.LIMIT, page = global.PAGE, filters = undefined) {
  return dispatch => {
    dispatch(request());

    orderService.getAll(limit, page, filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: orderConstants.GET_ORDERS_REQUEST } }
  function success(data) { return { type: orderConstants.GET_ORDERS_SUCCESS, data } }
  function failure(error) { return { type: orderConstants.GET_ORDERS_FAILURE, error } }
}
function add(orderValues) {
  return dispatch => {
    dispatch(request(orderValues));

    orderService.add(orderValues)
      .then(data => {
        dispatch(success()) && dispatch(alertActions.success(data.message))
        history.push(gisRoutes.management.order.edit.replace(':id', data.data.id))
        // window.location.reload(false); // HERE WE SHOULD HAVE A REDIRECT TO 'configure' DNIS

      }).catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });

  };

  function request() { return { type: orderConstants.ADD_ORDER_REQUEST } }
  function success() { return { type: orderConstants.ADD_ORDER_SUCCESS } }
  function failure(error) { return { type: orderConstants.ADD_ORDER_FAILURE, error } }
}

function update(order_id, updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    orderService.update(order_id, updatedValues)
      .then(
        data => {
          dispatch(success());
          dispatch(alertActions.success(data.message));
          if (['confirmed'].includes(updatedValues.status)) window.location.reload(false)
          else if (updatedValues.status != 'saved') history.push(gisRoutes.management.order.list);
          //
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: orderConstants.UPDATE_ORDER_REQUEST } }
  function success() { return { type: orderConstants.UPDATE_ORDER_SUCCESS } }
  function failure(error) { return { type: orderConstants.UPDATE_ORDER_FAILURE, error } }
}

function uploadFile(file, id, filetypes, order_id, customer_id) {
  const data = new FormData();
  // const allowedtypes = [];
  // filetypes.forEach(filetype => allowedtypes.push(portalFunctionalityConstants.documents[filetype]));
  // if (allowedtypes.includes(file.type) && file !== null) {
  data.append('file', file);
  return dispatch => {
    dispatch(request());
    orderService.uploadFile(data, order_id, customer_id, id)
      .then(
        data => dispatch(success(data)) && dispatch(alertActions.success(data.message)),
        error => dispatch(failure(error)) && dispatch(alertActions.error(error.data))
      );
  };
  // } else {
  //   return dispatch => {
  //     dispatch(failure(id))
  //     // dispatch(alertActions.error(`Please upload ${filetypes.map(e => e).join("/")} file`))
  //   }
  // }

  function request() { return { type: orderConstants.UPLOAD_FILE_ORDER_REQUEST } }
  function success(data) { return { type: orderConstants.UPLOAD_FILE_ORDER_SUCCESS, data } }
  function failure(error) { return { type: orderConstants.UPLOAD_FILE_ORDER_FAILURE, error } }
}

function downloadFile(filename, id, order_id, customer_id) {
  return dispatch => {

    orderService.downloadFile(filename, order_id, customer_id, id)
      .catch(error => {
        // dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

}
